import { rIC } from "../../utils";

function dialogController() {
  import("./dialog");
  import("./DrawerAccount");
  import("./DrawerFacets");
}

export default () => rIC(dialogController);
